import React, { useState } from "react";
import Placeholder from "../Placeholder.jsx";
import Activity from "./Activity.jsx";
import duckify, { filterDuck, singleDuck } from "../../utils/duckify.jsx";
import { activities, contacts } from "../../ducks/index.js";

const UserActivityList = ({ accessList, activityList, allDucksReady, contact, handleAddItemClick, userActivities }) => (
  <Placeholder.loading ready={allDucksReady} content={() => (
    userActivities.length > 0 ?
      <div className="notes-list">
        <ul>
          {userActivities.map(userActivity => (
            <li className={userActivity.type} key={userActivity.id} >
              <Activity
                activityModel={userActivity}
                accessList={accessList}
                activityList={activityList}
              />
            </li>)
          )}
        </ul>
      </div> :
      <div className="card bg-light no-notes empty">
        <span>
          {contact.first_name} doesn't have any notes, emails, or activities.
          <a href="#" className="add-item-text" onClick={handleAddItemClick}>You can add one here</a> or click the green plus sign.
        </span>
      </div>
  )
  } />
)

const mapDucksToProps = ({ contactId, filters }) => {
  return {
    contact: singleDuck(contacts, contactId),
    userActivities: filterDuck(activities, { contact_id: contactId, filters: filters })
  }
}

export default duckify(mapDucksToProps)(UserActivityList)
